<ebay-icon-button on-click("toggleTheme")>
  <if(state.checked)>
    <ebay-moon-16-icon />
  </if>
  <else>
    <ebay-lightbulb-16-icon />
  </else>
</ebay-icon-button>
